import { ChromosomeLocationColor } from "./ChromosomeLocationColor.js";

export const chromosomeLocationColorColorMap: Record<ChromosomeLocationColor, string> = {
	[ChromosomeLocationColor.Red]: "red",
	[ChromosomeLocationColor.Green]: "#98CE00",
	[ChromosomeLocationColor.Blue]: "#005FAA",
	[ChromosomeLocationColor.Yellow]: "yellow",
	[ChromosomeLocationColor.Orange]: "orange",
};
